/**
 * 処分方法（処分）
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/after_disposal_methods`

 const search_after_disposal_method = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     /**
      * 処分方法（処分）一覧の取得.
      * ドロップダウンで表示可能な内容を返します.
      * @return {Promise<unknown>}
      */
      index () {
        return new Promise((resolve) => {
          Vue.$http.get(API_PATH).then(data => {
            resolve(data.content)
          })
        })
      },
   },
   mutations: {},
 }
 export default search_after_disposal_method
 